import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">

          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">مدرسك</div>
            <p>منصة تعليمية مصرية تربط المدرسين المستقلين بالطلاب — كورسات مسجلة، حصص لايف، ومدفوعات إلكترونية في مكان واحد.</p>

            {/* Payment badges */}
            <div className="footer-payment-badges">
              <span className="fpb-title">طرق الدفع المقبولة</span>
              <div className="fpb-list">
                <span className="fpb">💳 فيزا</span>
                <span className="fpb">💳 ماستركارد</span>
                <span className="fpb">📱 فودافون كاش</span>
                <span className="fpb">🟠 اورنج كاش</span>
              </div>
              <div className="fpb-secure">
                🔒 مدفوعات آمنة عبر Paymob — مرخّصة من البنك المركزي المصري
              </div>
            </div>

            <div className="footer-socials">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noreferrer" aria-label="TikTok">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.74a4.85 4.85 0 01-1.01-.05z"/></svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>
              </a>
            </div>
          </div>

          {/* Quick links */}
          <div className="footer-col">
            <h4>روابط سريعة</h4>
            <Link to="/courses">الكورسات</Link>
            <Link to="/teachers">المدرسون</Link>
            <Link to="/register?role=teacher">انضم كمدرّس</Link>
            <Link to="/#faq">الأسئلة الشائعة</Link>
            <Link to="/reels">ريلز تعليمية</Link>
          </div>

          {/* Legal */}
          <div className="footer-col">
            <h4>قانوني وسياسات</h4>
            <Link to="/privacy">سياسة الخصوصية</Link>
            <Link to="/terms">الشروط والأحكام</Link>
            <Link to="/refund-policy">سياسة الاسترداد</Link>
            <Link to="/shipping-policy">سياسة التسليم</Link>
            <Link to="/teacher-agreement">اتفاقية المدرسين</Link>
          </div>

          {/* Company */}
          <div className="footer-col">
            <h4>الشركة</h4>
            <Link to="/about">عن مدرسك</Link>
            <Link to="/contact">اتصل بنا</Link>
            <div className="footer-contact-info">
              <span>📍 القاهرة، جمهورية مصر العربية</span>
              <a href="tel:+201013201998">📞 ‎+20 101 320 1998</a>
              <a href="mailto:madrasak.eg@gmail.com">✉️ madrasak.eg@gmail.com</a>
              <span>⏱ السبت – الخميس: 9ص – 9م</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} مدرسك. جميع الحقوق محفوظة.</span>
          <a href="https://mohamed-reda-swe-mohamedreda22s-projects.vercel.app/" target="_blank" rel="noreferrer" className="footer-dev-credit">
            تطوير بواسطة Mohamed Reda Web Solutions ⚡
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
